"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const Star = createSVGIcon(
  <path
    d="m12.844 1.87 2.713 5.501a.94.94 0 0 0 .708.515l6.072.884a.94.94 0 0 1 .515 1.603l-4.396 4.286a.94.94 0 0 0-.269.831l1.037 6.055a.94.94 0 0 1-1.371.99l-5.416-2.848a.94.94 0 0 0-.874 0l-5.43 2.856a.94.94 0 0 1-1.37-.99L5.8 15.5a.94.94 0 0 0-.27-.832l-4.388-4.289a.939.939 0 0 1 .514-1.603l6.079-.89a.94.94 0 0 0 .708-.514l2.714-5.5a.941.941 0 0 1 1.687 0Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Star",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "+x6jNG",
      defaultMessage: "Star",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: legacyIconCls(),
  })
);
